import  { useState } from 'react'
import toast from 'react-hot-toast';

const useTextComment = (id:number,removeComment:Function) => {
    const [showModal, setShowModal] = useState(false);
    const deleteComment = async()=>{
        await removeComment(id);
        setShowModal(false);
        return toast.success('Comment deleted');
    }
    return {
        showModal,
        setShowModal,
        deleteComment
    }
}

export default useTextComment